// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-password-brand_container-pVZq6 {
  margin: 24px;
}

.create-password-title-mHlhY {
  font-size: 22px;
  font-weight: 400;
  text-align: center;
  margin-top: 40px;
}

.create-password-title-mHlhY span {
  color: var(--accent-color);
  font-weight: 500;
}

.create-password-description-GjlaH {
  font-size: 20px;
  font-weight: 200;
  text-align: center;
  margin-top: 28px;
}

.create-password-card-hUvRo {
  width: 360px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  margin: 44px auto;
  padding: 20px;
}

.create-password-info-Bja2x {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.create-password-icon-n81cN {
  --size: 40px;
}

.create-password-name-Hrwqi {
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
}

.create-password-username-ZEm3y {
  color: var(--accent-color);
  margin-top: 12px;
}

.create-password-newPassword_container-XWD8S {
  width: 100%;
  margin-top: 48px;
}

.create-password-repeatPassword_container-G1dGb {
  width: 100%;
  margin-top: 28px;
  padding-bottom: 30px;
}

.create-password-showPassword-tE1Ce {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 15px;
  cursor: pointer;
  padding: 0px 4px;
}

.create-password-showPasswordTitle-o_tw8 {
  height: 20px;
  line-height: 20px;
}

.create-password-checkbox-Kl8uy {
  width: 15px;
  height: 15px;
  cursor: pointer;
  margin: 0px;
  margin-right: 8px;
}

.create-password-button_base-uBO6f {
  width: 160px;
  height: 36px;
  margin: 30px 0px 0px auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/create-password/create-password.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".brand_container {\n  margin: 24px;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: 400;\n  text-align: center;\n  margin-top: 40px;\n}\n\n.title span {\n  color: var(--accent-color);\n  font-weight: 500;\n}\n\n.description {\n  font-size: 20px;\n  font-weight: 200;\n  text-align: center;\n  margin-top: 28px;\n}\n\n.card {\n  width: 360px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  margin: 44px auto;\n  padding: 20px;\n}\n\n.info {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.icon {\n  --size: 40px;\n}\n\n.name {\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 20px;\n}\n\n.username {\n  composes: name;\n  color: var(--accent-color);\n  margin-top: 12px;\n}\n\n.newPassword_container {\n  width: 100%;\n  margin-top: 48px;\n}\n\n.repeatPassword_container {\n  width: 100%;\n  margin-top: 28px;\n  padding-bottom: 30px;\n}\n\n.showPassword {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  cursor: pointer;\n  padding: 0px 4px;\n}\n\n.showPasswordTitle {\n  height: 20px;\n  line-height: 20px;\n}\n\n.checkbox {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  margin: 0px;\n  margin-right: 8px;\n}\n\n.button_base {\n  width: 160px;\n  height: 36px;\n  margin: 30px 0px 0px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brand_container": `create-password-brand_container-pVZq6`,
	"title": `create-password-title-mHlhY`,
	"description": `create-password-description-GjlaH`,
	"card": `create-password-card-hUvRo`,
	"info": `create-password-info-Bja2x`,
	"icon": `create-password-icon-n81cN`,
	"name": `create-password-name-Hrwqi`,
	"username": `create-password-username-ZEm3y create-password-name-Hrwqi`,
	"newPassword_container": `create-password-newPassword_container-XWD8S`,
	"repeatPassword_container": `create-password-repeatPassword_container-G1dGb`,
	"showPassword": `create-password-showPassword-tE1Ce`,
	"showPasswordTitle": `create-password-showPasswordTitle-o_tw8`,
	"checkbox": `create-password-checkbox-Kl8uy`,
	"button_base": `create-password-button_base-uBO6f`
};
export default ___CSS_LOADER_EXPORT___;
